import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Re-export toast for components
export { toast };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      toastClassName={() =>
        "relative flex py-3.5 px-4 rounded-2xl overflow-hidden cursor-pointer bg-white shadow-panel border border-[rgba(11,61,46,0.08)]"
      }
      bodyClassName={() => "text-[#262626] text-sm font-medium font-sans"}
      position="bottom-left"
      autoClose={3500}
      hideProgressBar
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <App />
  </>
);
